export default __webpack_public_path__ + "static/ico-e0e8c60b949344b361136899cb12e26e.png";